<template>
  <div>
    <div class="mt-3 aulas-btns">
      <div>
        <v-btn icon to="/diario-escolar">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </div>
      <div class="bloco-btn mt-4" style="text-align: right">
        <v-btn
          width="90px"
          class="rounded-sm font-weight-regular"
          color="cyan"
          tile
          small
          :to="{
            name: AEEouACP
              ? 'diario-escolar-aula-aee-acp'
              : 'diario-escolar-aula',
            params: {
              ano,
              cdturma,
              disciplina,
              tipoDeEnsino,
              cdinstruc,
              pagina: paginaAtual,
              AEEouACP,
              filtro: this.filtroBusca,
            },
          }"
          aria-label="Novo"
          ><u>N</u>ovo</v-btn
        >
        <v-btn
          width="105px"
          color="cyan"
          class="rounded-sm font-weight-regular"
          tile
          small
          :disabled="aulas.length <= 0"
          :to="{
            name: 'diario-escolar-copiar-aulas',
            params: {
              ano,
              cdturma,
              disciplina,
              paginaAtual,
              filtroBusca,
              orderData,
              orderPeriodo,
              tipoDeEnsino,
              cdinstruc,
              AEEouACP,
              pagina: paginaAtual,
            },
          }"
        >
          Copiar Aula
        </v-btn>
        <v-btn
          width="105px"
          tile
          small
          color="cyan"
          class="rounded-sm font-weight-regular"
          v-if="AEEouACP"
          :disabled="aulas.length == 0 || aulasFrequencia == 0"
          :to="{
            name: 'diario-escolar-aulas-frequencia-aee-acp',
            params: {
              ano,
              cdturma,
              disciplina,
              aulas: aulasFrequencia,
              tipoDeEnsino,
              cdinstruc,
              AEEouACP,
              pagina: paginaAtual,
            },
          }"
          aria-label="Frequência"
        >
          Fre<u>q</u>uência
        </v-btn>
        <v-btn
          width="105px"
          small
          color="cyan"
          class="rounded-sm font-weight-regular"
          v-else
          :disabled="aulas.length == 0 || aulasFrequencia == 0"
          :to="{
            name: 'diario-escolar-aulas-frequencia',
            params: {
              ano,
              cdturma,
              disciplina,
              aulas: aulasFrequencia,
              tipoDeEnsino,
              cdinstruc,
              AEEouACP,
              pagina: paginaAtual,
            },
          }"
          aria-label="Frequência"
        >
          Fre<u>q</u>uência
        </v-btn>
        <v-btn
          class="rounded-sm font-weight-regular"
          width="170px"
          color="cyan"
          tile
          small
          :to="{
            name: 'diario-escolar-ausencia',
            params: {
              ano,
              cdturma,
              disciplina,
              tipoDeEnsino,
              cdinstruc,
              AEEouACP,
              pagina: paginaAtual,
            },
          }"
          >Gráfico de ausências</v-btn
        >
      </div>
    </div>
    <!-- <v-flex class="d-flex align-center justify-start"> -->
    <FiltroTable
      width="100px"
      ref="filtro"
      :options="optionsBusca"
      :quantidadeResultados="paginaTotal"
      @filtro="filtroRegistros"
    />
    <CheckBoxCustom
      trueValue="S"
      falseValue="N"
      v-model="filtroAulasLancadasPelaMatriculaDoUsuarioLogado"
      :label="`Mostrar aulas lançadas pelo usuário logado - Matrícula: ${this.userDadosPerfilAtual.cdpessoal}-${this.userDadosPerfilAtual.cdmatric}`"
      @input="reload()"
      :val="filtroAulasLancadasPelaMatriculaDoUsuarioLogado ? 'S' : 'N'"
    />

    <!-- </v-flex> -->

    <div>
      <v-alert
        v-if="aulas.length == 0"
        type="error"
        value="true"
        style="color: white"
      >
        <div>Nenhuma aula cadastrada!</div>
      </v-alert>
      <div v-else>
        <v-card>
          <v-flex xs12>
            <div>
              <div style="overflow-y: auto">
                <table class="table-siged">
                  <thead>
                    <tr>
                      <th>
                        <div
                          @click="mudarOrder('orderData')"
                          style="cursor: pointer"
                        >
                          Data
                          <v-icon
                            style="vertical-align: bottom; height: 22px"
                            >{{
                              orderData === "desc"
                                ? "arrow_drop_down"
                                : "arrow_drop_up"
                            }}</v-icon
                          >
                        </div>
                      </th>
                      <th>Assunto Lecionado</th>
                      <th>
                        <div
                          @click="mudarOrder('orderPeriodo')"
                          style="cursor: pointer"
                        >
                          Período Avaliativo
                          <v-icon
                            style="vertical-align: bottom; height: 22px"
                            >{{
                              orderPeriodo === "desc"
                                ? "arrow_drop_down"
                                : "arrow_drop_up"
                            }}</v-icon
                          >
                        </div>
                      </th>
                      <th class="sumir-mobile">Código</th>
                      <th>Ações</th>
                      <th colspan="2">
                        <span>Efetuar Frequência</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="20"
                              >notification_important</v-icon
                            >
                          </template>
                          <span class="text-caption white--text"
                            >Marcar mais de uma opção para aulas geminadas</span
                          >
                        </v-tooltip>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in aulas" :key="item.key">
                      <td>{{ item.dataaula | formatDataBRDia }}</td>
                      <td>{{ item.descricaoassuntolecionado }}</td>
                      <td>{{ item.dspravadi }}</td>
                      <td class="sumir-mobile">{{ item.identificadoraula }}</td>
                      <td
                        v-if="item.aberto.situacao === 'F'"
                        colspan="2"
                        class="centro"
                      >
                        {{ item.aberto.descricao.toUpperCase() }}
                      </td>
                      <template v-else>
                        <td class="centro">
                          <v-btn
                            icon
                            title="Editar aula"
                            class="aulas-btn-acao"
                            :to="{
                              name: AEEouACP
                                ? 'diario-escolar-aula-aee-acp'
                                : 'diario-escolar-aula',
                              params: {
                                id: item.identificadoraula,
                                ano,
                                cdturma,
                                AEEouACP,
                                disciplina,
                                tipoDeEnsino,
                                cdinstruc,
                                pagina: paginaAtual,
                              },
                            }"
                          >
                            <v-icon class="btn-acoes-icon">edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            title="Excluir aula"
                            class="aulas-btn-acao"
                            @click="excluir(item.identificadoraula)"
                          >
                            <!-- :disabled="item.frequencia_lancada" -->
                            <v-icon color="red">delete_forever</v-icon>
                          </v-btn>
                        </td>
                        <td class="centro">
                          <v-icon
                            style="cursor: pointer"
                            v-if="
                              dataAtual < item.dataaula ||
                              item.aberto.situacao === 'NA'
                            "
                            :title="
                              item.aberto.situacao === 'NA'
                                ? item.aberto.descricao
                                : 'Data futura'
                            "
                          >
                            lock
                          </v-icon>
                          <CheckBox
                            :aria-hidden="true"
                            :aria-label="
                            item.frequencia_lancada === true
                              ? 'Frequência lançada' 
                              : 'Frequência não lançada' 
                            "
                            v-else
                            v-model="aulasFrequencia"
                            :val="{
                              id: item.identificadoraula,
                              data: item.dataaula,
                            }"
                            :disabled="disabilitarFrequencia(item.dataaula)"
                          />
                        </td>
                      </template>

                      <td class="centro" style="width: 20px">
                        <v-icon>{{
                          item.frequencia_lancada ? "check" : "remove"
                        }}</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-siged-paginacao">
                <div
                  class="table-siged-info"
                  v-if="indicaHaAulasMinimasExigidas"
                >
                  <v-tooltip bottom style="flex: 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        size="20"
                        style="vertical-align: top"
                        >notification_important</v-icon
                      >
                      <div
                        style="flex: 1"
                        v-for="(key) in legendaRodaPe"
                        :key="key.descricao"
                      >
                        <i
                          ><strong>{{ key.descricao }}:</strong>
                          {{ `${key.qnt}/${key.total}` }}</i
                        >
                      </div>
                    </template>

                    <span class="text-caption white--text"
                      >Aulas com frequência / Quantidade de Aulas</span
                    >
                  </v-tooltip>
                </div>
                <div v-if="quantidadePaginas > 1" class="table-siged-page">
                  <v-pagination
                    v-model="paginaAtual"
                    :length="quantidadePaginas"
                    total-visible="7"
                  />
                </div>
              </div>
            </div>
          </v-flex>
        </v-card>
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="4000"
      height="10px"
      rounded="0"
    >
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import store from "@/store/index";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import FiltroTable from "@/components/FiltroTable";
import { mapGetters } from "vuex";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");
const PeriodoAvaliativoRepository = RepositoryFactory.get("periodoAvaliativo");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const buscarAulas = async (
  aaletivo,
  cdturma,
  cddiscipl,
  cdinstruc,
  AEEouACP,
  filtroAulasLancadasPelaMatriculaDoUsuarioLogado = "S",
  page = 1,
  filtro = {},
  orderdata = "desc",
  orderperiodo = "desc"
) => {
  if (
    JSON.parse(sessionStorage.getItem("filtro.tipo")) !== "" &&
    JSON.parse(sessionStorage.getItem("filtro.tipo")) !== undefined &&
    JSON.parse(sessionStorage.getItem("filtro.tipo")) !== null
  ) {
    filtro[JSON.parse(sessionStorage.getItem("filtro.tipo"))] = JSON.parse(
      sessionStorage.getItem("filtro.busca")
    );
  } else {
    filtro = {};
  }

  return await DiarioEscolarRepository.getAulasProfessor({
    ...dadosUser(),
    aaletivo,
    cdturma,
    cddiscipl,
    page,
    orderdata,
    orderperiodo,
    ...filtro,
    cdinstruc,
    AEEouACP,
    filtroAulasLancadasPelaMatriculaDoUsuarioLogado,
  });
};

const buscarQntValoresPeriodo = async (aaletivo, cdturma, cddiscipl) => {
  try {
    const { data } = await PeriodoAvaliativoRepository.getAulasPorPeriodo({
      ...dadosUser(),
      aaletivo,
      cdturma,
      cddiscipl,
    });

    return data;
  } catch (error) {
    return {};
  }
};

export default {
  name: "Aulas",
  components: {
    FiltroTable,
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    pagina: [Number],
    filtro: [Object],
    AEEouACP: [Boolean],
  },
  created() {
    window.addEventListener("keydown", this.atalhoParaNovo);
    window.addEventListener("keydown", this.atalhoParaFrequencia);
  },
  data() {
    return {
      aulas: [],
      indicaHaAulasMinimasExigidas: true,
      aulasFrequencia: [],
      snackbar: false,
      submitText: "",
      paginaAtual: this.pagina !== undefined ? this.pagina : 1,
      paginaTotal: 0,
      quantidadePaginas: 0,
      dataAtual: "",
      legendaRodaPe: [],
      chaveSessionStorageBusca: "filtro.busca",
      chaveSessionStorageTipo: "filtro.tipo",
      optionsBusca: [
        { text: "Período Avaliativo", value: "dspravadi", type: "text" },
        { text: "Data", value: "dataaula", type: "date" },
        {
          text: "Assunto Lecionado",
          value: "descricaoassuntolecionado",
          type: "text",
        },
      ],
      filtroBusca: {},
      orderData: "desc",
      orderPeriodo: "desc",
      filtroAulasLancadasPelaMatriculaDoUsuarioLogado: "S",
    };
  },
  updated: function () {
    if (
      JSON.parse(sessionStorage.getItem(this.chaveSessionStorageBusca)) !==
        "" &&
      JSON.parse(sessionStorage.getItem(this.chaveSessionStorageBusca)) !==
        undefined &&
      JSON.parse(sessionStorage.getItem(this.chaveSessionStorageBusca)) !== null
    ) {
      this.$refs.filtro.busca = JSON.parse(
        sessionStorage.getItem(this.chaveSessionStorageBusca)
      );
    } else {
      sessionStorage.setItem(
        this.chaveSessionStorageBusca,
        JSON.stringify(this.$refs.filtro.buscaFiltro)
      );
    }
  },
  async beforeRouteEnter(to, from, next) {
    if (
      typeof to.params.ano === "undefined" ||
      typeof to.params.cdturma === "undefined" ||
      typeof to.params.disciplina === "undefined"
    ) {
      return next("/diario-escolar");
    }
    const { data } = await buscarAulas(
      to.params.ano,
      to.params.cdturma,
      to.params.disciplina,
      to.params.cdinstruc,
      to.params.AEEouACP,
      "S",
      to.params.pagina
    );
    const responsePeriodo = await buscarQntValoresPeriodo(
      to.params.ano,
      to.params.cdturma,
      to.params.disciplina
    );

    return next((vm) => {
      vm.reload(data);
      vm.exibirLegendaQuantidadePeriodo(responsePeriodo);
    });
  },
  watch: {
    paginaAtual(valorNew) {
      this.reload();
    },
  },
  methods: {
    async reload(data = null, excluido = false) {
      if (!data) {
        this.$Progress.start();

        const retorno = await buscarAulas(
          this.ano,
          this.cdturma,
          this.disciplina,
          this.cdinstruc,
          this.AEEouACP,
          this.filtroAulasLancadasPelaMatriculaDoUsuarioLogado,
          this.paginaAtual,
          this.filtroBusca,
          this.orderData,
          this.orderPeriodo
        );
        data = retorno.data;
        if (excluido) {
          const responsePeriodo = await buscarQntValoresPeriodo(
            this.ano,
            this.cdturma,
            this.disciplina
          );
          this.exibirLegendaQuantidadePeriodo(responsePeriodo);
        }
      }

      this.aulasFrequencia = [];
      this.aulas = [...data.results.aulas.data];
      this.paginaTotal = data.results.aulas.total;
      this.quantidadePaginas = data.results.aulas.last_page;
      this.$Progress.finish();
      this.dataAtual = data.results.data_atual;

      if (
        JSON.parse(sessionStorage.getItem(this.chaveSessionStorageTipo)) !==
          "" &&
        JSON.parse(sessionStorage.getItem(this.chaveSessionStorageTipo)) !==
          undefined &&
        JSON.parse(sessionStorage.getItem(this.chaveSessionStorageTipo)) !==
          null
      ) {
        this.$refs.filtro.tipo = JSON.parse(
          sessionStorage.getItem(this.chaveSessionStorageTipo)
        );
      } else {
        sessionStorage.setItem(
          this.chaveSessionStorageTipo,
          JSON.stringify(this.$refs.filtro.tipoFiltro)
        );
      }
    },
    disabilitarFrequencia(data) {
      if (typeof this.aulasFrequencia[0] === "undefined") {
        return false;
      }

      return this.aulasFrequencia[0].data !== data;
    },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: "Tem certeza?",
        text: "Deseja realmente excluir esta aula?",
        type: "warning",
        buttons: [
          { text: "Excluir", color: "red", response: true },
          { text: "Cancelar", color: "grey", response: false },
        ],
      });
      if (!confirmar) {
        return;
      }

      try {
        const { data } = await DiarioEscolarRepository.deleteAula(id);

        //this.aulas = [];
        this.submitText = data.message;
        this.snackbar = true;
        if (this.paginaAtual > 1 && this.aulas.length == 1) {
          this.paginaAtual--;
        }
        this.reload(null, true);
      } catch (error) {
        if (error.response) {
          this.$sgal({
            title: "Não foi possível!",
            text: error.response.data.errorMessage[0],
            type: "notification",
          });
        }
      }
    },
    exibirLegendaQuantidadePeriodo(data) {
      let qntAulasComFrequenciaAnual = 0;
      let qntAulasAnual = 0;
      this.indicaHaAulasMinimasExigidas =
        data.configurcaoAnoLetivo.indicaexigenumerodeaulas === "S";

      this.legendaRodaPe = data.results.map((key) => {
        qntAulasAnual += key.qtaulaper;
        qntAulasComFrequenciaAnual += key.quantidade_aulas_frequencia;

        return {
          descricao: key.dspravadi,
          qnt: key.quantidade_aulas_frequencia,
          total: key.qtaulaper,
        };
      });

      this.legendaRodaPe.push({
        descricao: "Anual",
        qnt: qntAulasComFrequenciaAnual,
        total: qntAulasAnual,
      });
      this.legendaRodaPe = this.legendaRodaPe.reverse()
    },
    async filtroRegistros(data) {
      this.paginaAtual = 1;
      this.filtroBusca = data.filtro;
      this.$refs.filtro.exibirFiltro = false;
      sessionStorage.setItem(
        this.chaveSessionStorageBusca,
        JSON.stringify(this.$refs.filtro.buscaFiltro)
      );
      sessionStorage.setItem(
        this.chaveSessionStorageTipo,
        JSON.stringify(this.$refs.filtro.tipoFiltro)
      );
      await this.reload();
      this.$refs.filtro.exibirFiltro = data.exibir;
    },
    mudarOrder(aux) {
      this[aux] = this[aux] === "desc" ? "asc" : "desc";
      this.reload();
    },
    atalhoParaNovo(event) {
      if (event.altKey && event.key === "n") {
        this.$router.push({
          name: this.AEEouACP
            ? "diario-escolar-aula-aee-acp"
            : "diario-escolar-aula",
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            tipoDeEnsino: this.tipoDeEnsino,
            cdinstruc: this.cdinstruc,
            pagina: this.paginaAtual,
            AEEouACP: this.AEEouACP,
            filtro: this.filtroBusca,
          },
        });
      }
    },
    atalhoParaFrequencia(event) {
      const botaoDisabled =
        this.aulas.length === 0 || this.aulasFrequencia.length === 0;

      if (event.altKey && event.key === "q" && !botaoDisabled) {
        this.$router.push({
          name: this.AEEouACP
            ? "diario-escolar-aulas-frequencia-aee-acp"
            : "diario-escolar-aulas-frequencia",
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            aulas: this.aulasFrequencia,
            tipoDeEnsino: this.tipoDeEnsino,
            cdinstruc: this.cdinstruc,
            AEEouACP: this.AEEouACP,
            pagina: this.paginaAtual,
          },
        });
      } else return;
    },
  },
  computed: {
    ...mapGetters(["userDadosPerfilAtual"]),
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.atalhoParaFrequencia);
    window.removeEventListener("keydown", this.atalhoParaNovo);
  },
};
</script>

<style lang="scss">
.aulas-btns {
  display: flex;

  & > div {
    flex: 1;
  }
  .bloco-btn {
    .v-btn {
      margin-left: 20px;
    }

    .v-btn__content {
      color: white;
    }

    .icon {
      margin: 0 !important;
      padding: 10px;
      i {
        color: black !important;
      }
    }
  }
}
.btn-acoes-icon {
  color: #4e4e4e !important;
}
.aulas-btn-acao {
  margin: 0px;
}

@media only screen and (max-width: 900px) {
  .sumir-mobile {
    display: none;
  }
}
</style>
